import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button as MUIButton,
  Box,
} from "@mui/material";
import {
  CheckCircle as CheckCircleIcon,
  Email as EmailIcon,
  Person as PersonIcon,
  Business as BusinessIcon,
} from "@mui/icons-material";

const SuccessModal = ({
  open,
  onClose,
  onConfirm,
  title = "Account Created Successfully!",
  message = "A password setup email has been sent to the user.",
  confirmText = "View Profile",
  cancelText = "Stay Here",
  userName,
  userEmail,
  username,
  userRole,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 3,
          minWidth: 480,
          maxWidth: 520,
          textAlign: "center",
        },
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <Box
          sx={{
            width: 80,
            height: 80,
            borderRadius: "50%",
            bgcolor: "#E8F5E9",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CheckCircleIcon sx={{ fontSize: 48, color: "#2E7D32" }} />
        </Box>
      </Box>

      <DialogTitle
        sx={{
          fontWeight: 700,
          fontSize: 24,
          pt: 2,
          pb: 1,
          color: "#1A1A2E",
        }}
      >
        {title}
      </DialogTitle>

      <DialogContent sx={{ py: 0 }}>
        <Typography
          sx={{
            color: "#64748B",
            fontSize: 15,
            lineHeight: 1.6,
            mb: 3,
          }}
        >
          {message}
        </Typography>

        {(userName || userEmail || username || userRole) && (
          <Box
            sx={{
              bgcolor: "#F8FAFC",
              borderRadius: 2,
              p: 2.5,
              textAlign: "left",
              border: "1px solid #E2E8F0",
            }}
          >
            {userName && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5 }}>
                <PersonIcon sx={{ color: "#64748B", fontSize: 20 }} />
                <Typography variant="body2" sx={{ color: "#475569" }}>
                  <strong>Name:</strong> {userName}
                </Typography>
              </Box>
            )}

            {userEmail && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5 }}>
                <EmailIcon sx={{ color: "#64748B", fontSize: 20 }} />
                <Typography variant="body2" sx={{ color: "#475569" }}>
                  <strong>Email:</strong> {userEmail}
                </Typography>
              </Box>
            )}

            {username && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5 }}>
                <PersonIcon sx={{ color: "#64748B", fontSize: 20 }} />
                <Typography variant="body2" sx={{ color: "#475569" }}>
                  <strong>Username:</strong> <Box component="span" sx={{ fontWeight: 600, color: "#2563EB" }}>{username}</Box>
                </Typography>
              </Box>
            )}

            {userRole && (
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                <BusinessIcon sx={{ color: "#64748B", fontSize: 20 }} />
                <Typography variant="body2" sx={{ color: "#475569" }}>
                  <strong>Role:</strong> <Box component="span" sx={{ textTransform: "capitalize" }}>{userRole}</Box>
                </Typography>
              </Box>
            )}
          </Box>
        )}

        <Box
          sx={{
            mt: 3,
            p: 2,
            bgcolor: "#E3F2FD",
            borderRadius: 2,
            border: "1px solid #90CAF9",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              color: "#1565C0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 1,
              fontWeight: 500,
            }}
          >
            <EmailIcon sx={{ fontSize: 18 }} />
            Password setup instructions have been sent to the user's email
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
          gap: 2,
          pb: 2,
          pt: 2,
        }}
      >
        <MUIButton
          variant="contained"
          onClick={onConfirm}
          sx={{
            px: 5,
            py: 1.5,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            fontSize: 15,
            bgcolor: "#2563EB",
            "&:hover": {
              bgcolor: "#1D4ED8",
            },
          }}
        >
          {confirmText}
        </MUIButton>
        <MUIButton
          variant="outlined"
          onClick={onClose}
          sx={{
            px: 5,
            py: 1.5,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            fontSize: 15,
            color: "#64748B",
            borderColor: "#E2E8F0",
            "&:hover": {
              borderColor: "#94A3B8",
              bgcolor: "#F8FAFC",
            },
          }}
        >
          {cancelText}
        </MUIButton>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessModal;